import { SectionHeader } from 'components/sections/header';
import { SectionName } from 'enums/route.enums';
import { useNavSections } from 'hooks/useNavSections';
import { t } from 'i18next';
import { IMenuAction } from 'interfaces/i-menus';

export const AnalyticsHeader = ({ actions }: { actions?: IMenuAction[] }) => {
  const { userSections } = useNavSections();

  return (
    <SectionHeader
      header={t('main.analytics')}
      subsections={
        userSections.find((s) => s.value === SectionName.Analytics)?.subsections
      }
      actions={actions}
    />
  );
};
